import type { FaireProductEntity } from "../../entity_types/product";

export const p_s47cxjrzds: FaireProductEntity = {
  token: "p_s47cxjrzds",
  type: "product",
  name: "Game Day Gold Plated Bar Necklace",
  brandToken: "b_vswk7rntc2",
  brandName: "SP Sophia Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/9756b10bdf44adc852d6b8763dab811d17b37679d946d32d5ec1ad00ed81b0b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b0bcbb6e7a3b952495f3156b5e0a009e68bcfe01e9e3cfa029dd8669e20f2af.jpeg",
    "https://cdn.faire.com/fastly/deff5f5111fc8d72fdbcd4553369dfbfa12c1d23286497984f5aeae1f98fa330.jpeg",
    "https://cdn.faire.com/fastly/d299f528f5ab97cdaf5a7d3c0b50af53b99fe75860ed6df1d8411c3d42352285.jpeg",
    "https://cdn.faire.com/fastly/4cd027f69ea96ef7f34fea812b5b0402a5edf4772086b0be56681536da8670de.jpeg",
    "https://cdn.faire.com/fastly/84f2b6ff6cf860ce1c6ae5dba78e29f55c6a398dd8531de5c87b0bf579582a34.jpeg",
    "https://cdn.faire.com/fastly/081a467dac47a9bef73c9e50db0ebed4e15ca145add3ea7381a6baf1135ef728.jpeg",
    "https://cdn.faire.com/fastly/e94e3c28cfcd30e745f4781030d14b52c9c251425767dd0e71d871bd8dec97c1.jpeg",
    "https://cdn.faire.com/fastly/49a6d624c026bdf8226b20c6929ee0ddd643791765dc95720b34b5fc24022f88.jpeg",
    "https://cdn.faire.com/fastly/2f435f4fb81327a24cb3f03ac38d2c45ec12b9366d843f8c33e80fcded417b3f.jpeg",
  ],
  priceDollars: 12.47,
  description:
    'Introducing the Bridget Game Day Letter Beaded Rhinestone Post Earrings, perfect for game day! Designed with a gold plated bar necklace, these earrings are adorned with sparkling rhinestones and beaded accents. Get ready to show off your team spirit in style!\n\n*** MADE IN KOREA***\n\nLENGTH: 16.5" EXTENSION:1" DROP: 0.25"',
  tags: [],
  msrpDollars: 49.88,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:20.897Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
